/* PHD on Dragons — store behaviour: cart drawer, buy box, sticky bar, timers, popup.
   No dependencies. The cinematic sky and teaser live in dragon.js. */
(() => {
'use strict';
const T = window.theme || {};
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches, root = document.documentElement;
const store = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
};

/* ---------- money ---------- */
/* Prices from Shopify (variant JSON, /cart.js) are already converted to the visitor's
   currency by Shopify Markets. Format them in that currency, not the shop's base format,
   otherwise a euro amount would be shown with a dollar sign. */
const moneyFmtCache = {};
function formatMoney(cents, format) {
  if (!format && T.currency && T.currency !== T.shopCurrency && typeof Intl !== 'undefined' && Intl.NumberFormat) {
    const n = (Number(typeof cents === 'string' ? cents.replace('.', '') : cents) || 0) / 100;
    try {
      const key = T.locale + T.currency;
      const f = moneyFmtCache[key] || (moneyFmtCache[key] = new Intl.NumberFormat(T.locale, { style: 'currency', currency: T.currency }));
      return f.format(n);
    } catch (e) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: T.currency }).format(n); } catch (e2) {}
    }
  }
  return formatMoneyPattern(cents, format);
}
function formatMoneyPattern(cents, format = T.moneyFormat || '${{amount}}') {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const n = Number(cents) || 0;
  const fmt = (v, d = 2, t = ',', dec = '.') => {
    const s = (v / 100).toFixed(d).split('.');
    return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (s[1] ? dec + s[1] : '');
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: fmt(n), amount_no_decimals: fmt(n, 0), amount_with_comma_separator: fmt(n, 2, '.', ','),
    amount_no_decimals_with_comma_separator: fmt(n, 0, '.', ','), amount_with_apostrophe_separator: fmt(n, 2, "'", '.'),
    amount_no_decimals_with_space_separator: fmt(n, 0, ' ', ''), amount_with_space_separator: fmt(n, 2, ' ', ','),
    amount_with_period_and_space_separator: fmt(n, 2, ' ', '.')
  }[k] || fmt(n)));
}
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

/* ---------- toast ---------- */
let toastT;
function toast(msg, ms = 5000) {
  const el = $('#toast'); if (!el) return;
  el.textContent = msg; el.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('show'), ms);
}

/* ---------- drawers and modals ---------- */
let lastFocus = null;
function openLayer(el) {
  if (!el) return; lastFocus = document.activeElement;
  el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('no-scroll');
  const f = el.querySelector('[data-close].icon-btn, button, a, input'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
}
function closeLayer(el) {
  if (!el || !el.classList.contains('is-open')) return;
  el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
  if (!$('.drawer.is-open, .modal.is-open')) document.documentElement.classList.remove('no-scroll');
  if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
}
document.addEventListener('click', e => {
  const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openLayer(document.getElementById(o.dataset.open)); return; }
  const c = e.target.closest('[data-close]'); if (c) { closeLayer(c.closest('.drawer, .modal')); }
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open').forEach(closeLayer); });

/* ---------- cart ---------- */
const drawer = $('#CartDrawer');
const rate = () => (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
async function getCart() { const r = await fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
function paintCount(n) {
  $$('[data-cart-count]').forEach(el => {
    el.textContent = n > 0 ? n : ''; el.dataset.count = n;
    el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    const a = el.closest('a'); if (a) a.setAttribute('aria-label', 'Cart, ' + n + ' items');
  });
}
function paintShipBars(cart) {
  if (!T.freeShip) return;
  const goal = Math.round(T.freeShip * rate()), left = Math.max(0, goal - cart.total_price), pct = Math.min(100, cart.total_price / goal * 100);
  $$('[data-ship-bar]').forEach(bar => {
    bar.hidden = cart.item_count === 0;
    const t = $('[data-ship-text]', bar), m = $('[data-ship-meter]', bar);
    t.innerHTML = left > 0 ? esc(T.freeShipText).replace('[amount]', '<b>' + esc(formatMoney(left)) + '</b>') : esc(T.freeShipDone);
    m.style.setProperty('--v', pct + '%');
  });
}
/* ---------- offers: free gifts + world-aware add-ons (data from snippets/offers-data.liquid) ---------- */
const OD = (() => { try { return JSON.parse(($('#OffersData') || {}).textContent || '{}'); } catch (e) { return {}; } })();
const offerOver = () => { const e = OD.offerEnd && parseEnd(OD.offerEnd); return !!(e && e <= new Date()); };
const has = (cart, ids) => (ids || []).some(id => cart.items.some(i => i.product_id === id));
const worldOf = cart => has(cart, OD.alienBooks) && !has(cart, OD.dragonBooks) ? 'alien' : 'dragon';
const giftVariant = g => {
  const saved = +store.get('podGift' + g.id);
  return g.variants.find(v => v.id === saved && v.available) || g.variants.find(v => v.available);
};
let syncing = false;
async function syncGifts(cart) {
  if (syncing || !OD.gifts || !OD.gifts.length) return cart;
  const qualifies = OD.giftOn && !offerOver() && has(cart, OD.dragonBooks);
  const giftLines = cart.items.map((it, i) => ({ it, line: i + 1 })).filter(x => x.it.properties && x.it.properties._gift);
  syncing = true;
  try {
    if (!qualifies && giftLines.length) {
      const updates = {}; giftLines.forEach(x => { updates[x.it.key] = 0; });
      await fetch(T.routes.root.replace(/\/?$/, '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      return await getCart();
    }
    if (qualifies) {
      const items = OD.gifts.filter(g => !cart.items.some(i => i.product_id === g.id)).map(g => giftVariant(g)).filter(Boolean)
        .map(v => ({ id: v.id, quantity: 1, properties: { _gift: 'Free with PHD on Dragons' } }));
      if (items.length) {
        await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        return await getCart();
      }
    }
  } catch (e) {} finally { syncing = false; }
  return cart;
}
async function paintUpsell(cart) {
  const box = drawer && $('[data-upsell]', drawer); if (!box || root.classList.contains('aw-page')) return;
  const list = (OD[worldOf(cart)] || {}), picks = (list.items || [])
    .filter(p => !cart.items.some(i => i.product_id === p.id) && p.variants.some(v => v.available))
    .slice(0, OD.drawerCount || 3);
  if (!picks.length || !cart.item_count) { box.innerHTML = ''; return; }
  box.innerHTML = `<div class="upsells"><p class="upsells__h">${esc(list.heading || 'Complete your hoard')}</p>` + picks.map(p => {
    const v = p.variants.find(x => x.available), img = p.image || '';
    const opts = p.single ? '' : `<select class="upsell__opt" data-upsell-opt aria-label="${esc(p.title)} option">${p.variants.map(x => `<option value="${x.id}"${x.available ? '' : ' disabled'}${x.id === v.id ? ' selected' : ''}>${esc(x.title)}</option>`).join('')}</select>`;
    return `<div class="upsell">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : '<span></span>'}
      <div><a class="citem__t" href="${esc(p.url)}">${esc(p.title)}</a><span class="citem__v">${esc(formatMoney(v.price))}${v.compare > v.price ? ` <s>${esc(formatMoney(v.compare))}</s>` : ''}</span>${opts}</div>
      <button class="btn--ghost" type="button" data-upsell-add="${v.id}">Add</button></div>`;
  }).join('') + '</div>';
}
function renderDrawer(cart) {
  if (!drawer) return;
  const list = $('[data-cart-items]', drawer), empty = $('[data-cart-empty]', drawer), foot = $('[data-cart-foot]', drawer);
  empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
  list.innerHTML = cart.items.map((it, i) => {
    const img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : '';
    const variant = it.product_has_only_default_variant ? '' : `<span class="citem__v">${esc(it.variant_title)}</span>`;
    const was = it.original_line_price > it.final_line_price ? `<s>${esc(formatMoney(it.original_line_price))}</s>` : '';
    const gift = it.properties && it.properties._gift, g = gift && (OD.gifts || []).find(x => x.id === it.product_id);
    if (gift) {
      const sizes = g && !g.single ? `<select class="upsell__opt" data-gift-swap aria-label="Size">${g.variants.map(x => `<option value="${x.id}"${x.available ? '' : ' disabled'}${x.id === it.variant_id ? ' selected' : ''}>${esc(x.title)}</option>`).join('')}</select>` : '';
      return `<li class="citem citem--gift" data-line="${i + 1}" data-key="${esc(it.key)}">
      <a href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
      <div><span class="gift-tag">Free gift</span><a class="citem__t" href="${esc(it.url)}">${esc(it.product_title)}</a>${sizes}</div>
      <p class="citem__p">${it.final_line_price === 0 ? `<s>${esc(formatMoney(it.original_line_price))}</s>FREE` : esc(formatMoney(it.final_line_price))}</p></li>`;
    }
    return `<li class="citem" data-line="${i + 1}">
      <a href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
      <div><a class="citem__t" href="${esc(it.url)}">${esc(it.product_title)}</a>${variant}
        <div class="qty" data-qty data-line-qty><button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>
        <input type="number" value="${it.quantity}" min="0" aria-label="Quantity for ${esc(it.product_title)}" inputmode="numeric">
        <button type="button" data-step="1" aria-label="Increase quantity">+</button></div>
        <br><button class="citem__rm" type="button" data-remove>Remove</button></div>
      <p class="citem__p">${was}${esc(formatMoney(it.final_line_price))}</p></li>`;
  }).join('');
  $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
  paintUpsell(cart);
}
async function refreshCart(open) {
  try {
    const cart = await syncGifts(await getCart());
    paintCount(cart.item_count); paintShipBars(cart); renderDrawer(cart);
    if (open) openLayer(drawer);
    return cart;
  } catch (e) { return null; }
}
let changing = Promise.resolve();
function changeLine(line, quantity) {
  changing = changing.then(async () => {
    drawer.style.cursor = 'progress';
    try {
      const r = await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const cart = await r.json();
      if (!r.ok) toast(cart.description || 'That quantity is not available.');
      await refreshCart(false);
    } finally { drawer.style.cursor = ''; }
  });
}
if (drawer) {
  drawer.addEventListener('click', e => {
    const li = e.target.closest('[data-line]'); if (!li) {
      const up = e.target.closest('[data-upsell-add]');
      if (up) { const o = up.parentElement.querySelector('[data-upsell-opt]'); addToCart({ items: [{ id: +(o ? o.value : up.dataset.upsellAdd), quantity: 1 }] }, up); }
      return;
    }
    if (e.target.closest('[data-remove]')) changeLine(+li.dataset.line, 0);
  });
  drawer.addEventListener('change', async e => {
    const sw = e.target.closest('[data-gift-swap]'); if (!sw) return;
    const li = sw.closest('[data-key]'), g = (OD.gifts || []).find(x => x.variants.some(v => v.id === +sw.value));
    if (g) store.set('podGift' + g.id, sw.value);
    syncing = true;
    try {
      await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: li.dataset.key, quantity: 0 }) });
      await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +sw.value, quantity: 1, properties: { _gift: 'Free with PHD on Dragons' } }] }) });
    } finally { syncing = false; }
    refreshCart(false);
  });
  drawer.addEventListener('change', e => { if (e.target.closest('[data-gift-swap], [data-upsell-opt]')) return; const li = e.target.closest('[data-line]'); if (li && e.target.matches('input')) changeLine(+li.dataset.line, Math.max(0, parseInt(e.target.value, 10) || 0)); });
}
document.addEventListener('click', e => {
  const a = e.target.closest('[data-cart-open]');
  if (a && drawer && T.cartType === 'drawer' && !document.body.classList.contains('template-cart')) { e.preventDefault(); refreshCart(true); }
});

async function addToCart(body, btn, form) {
  const msg = form && $('[data-buy-msg]', form.closest('[data-buy]') || form);
  if (msg) msg.hidden = true;
  if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
  try {
    const isForm = body instanceof FormData;
    const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body: isForm ? body : JSON.stringify(body) });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
    if (T.cartType === 'checkout') { location.href = '/checkout'; return; }
    if (T.cartType === 'page' || !drawer) { location.href = T.routes.cart; return; }
    await refreshCart(true);
    document.dispatchEvent(new CustomEvent('pod:added'));
  } catch (err) {
    if (msg) { msg.textContent = err.message; msg.hidden = false; } else toast(err.message);
  } finally {
    if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
  }
}
document.addEventListener('submit', e => {
  const form = e.target.closest('form[data-ajax-cart]'); if (!form) return;
  e.preventDefault();
  const btn = e.submitter && e.submitter.type === 'submit' ? e.submitter : form.querySelector('[type=submit]');
  const fd = new FormData(form);
  /* the quantity input lives outside the form (form= attribute), FormData picks it up in modern browsers; make sure */
  if (!fd.get('quantity') && form.id) { const q = document.querySelector(`input[name=quantity][form="${form.id}"]`); if (q) fd.set('quantity', q.value); }
  const ao = form.closest('[data-buy]') && $('[data-addons]', form.closest('[data-buy]'));
  const extras = ao ? $$('[data-addon]:checked', ao).map(c => ({ id: +c.value, quantity: 1 })) : [];
  if (extras.length && fd.get('id')) {
    addToCart({ items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }, ...extras] }, btn, form);
    return;
  }
  addToCart(fd, btn, form);
});

/* ---------- quantity steppers ---------- */
document.addEventListener('click', e => {
  const b = e.target.closest('[data-qty] [data-step]'); if (!b) return;
  const inp = b.parentElement.querySelector('input'); const min = +inp.min || 0;
  inp.value = Math.max(min, (parseInt(inp.value, 10) || 0) + +b.dataset.step);
  inp.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---------- buy box: variants, price, stock ---------- */
function initBuy(box) {
  if (box.dataset.ready) return; box.dataset.ready = '1';
  let variants = []; try { variants = JSON.parse($('[data-variants]', box).textContent); } catch (e) { return; }
  const sid = box.dataset.section, root = box.closest('[data-product-section]') || box.parentElement;
  const idInput = $('[data-variant-id]', box), add = $('[data-add]', box), sticky = document.querySelector(`[data-sticky-buy] [form="product-form-${sid}"]`);
  const scar = $('[data-scarcity]', box);
  const radios = $$('input[data-opt]', box);
  function current() {
    const chosen = []; radios.filter(r => r.checked).forEach(r => { chosen[+r.dataset.opt] = r.value; });
    return variants.find(v => v.options.every((o, i) => o === chosen[i]));
  }
  function paintScarcity(v) {
    if (!scar) return;
    const txt = $('[data-scarcity-text]', scar), meter = $('[data-scarcity-meter]', scar), th = +scar.dataset.threshold, max = +scar.dataset.max;
    scar.classList.remove('scarcity--ok');
    if (!v || !v.available) { txt.textContent = scar.dataset.out; if (meter) meter.hidden = true; return; }
    if (v.inv != null && v.inv > 0 && v.inv <= th) {
      txt.textContent = scar.dataset.low.replace('[count]', v.inv);
      if (meter) { meter.hidden = false; meter.firstElementChild.style.setProperty('--v', Math.max(4, Math.min(100, v.inv / max * 100)) + '%'); }
    } else { txt.textContent = scar.dataset.ok; scar.classList.add('scarcity--ok'); if (meter) meter.hidden = true; }
  }
  function paint(v) {
    const ok = v && v.available;
    if (idInput && v) idInput.value = v.id;
    if (add) { add.disabled = !ok; add.textContent = !v ? 'Unavailable' : ok ? add.dataset.label : add.dataset.sold; }
    if (sticky) sticky.disabled = !ok;
    const now = $('[data-price-now]', box), was = $('[data-price-was]', box), save = $('[data-price-save]', box);
    if (v && now) {
      now.textContent = formatMoney(v.price);
      const sale = v.compare > v.price;
      if (was) { was.hidden = !sale; was.textContent = sale ? formatMoney(v.compare) : ''; }
      if (save) { save.hidden = !sale; if (sale) save.textContent = 'Save ' + Math.round((v.compare - v.price) / v.compare * 100) + '%'; }
      const sp = document.querySelector(`[data-sticky-buy] [data-sticky-price]`); if (sp && sticky) sp.textContent = formatMoney(v.price);
    }
    $$('[data-opt-value]', box).forEach(el => { const r = radios.find(x => x.checked && x.dataset.opt === el.dataset.optValue); if (r) el.textContent = r.value; });
    /* mark option values that no available variant can reach from the current choice */
    radios.forEach(r => {
      const i = +r.dataset.opt, others = radios.filter(x => x.checked && +x.dataset.opt !== i);
      const reach = variants.some(vv => vv.available && vv.options[i] === r.value && others.every(o => vv.options[+o.dataset.opt] === o.value));
      r.classList.toggle('is-unavailable', !reach);
    });
    paintScarcity(v);
    if (v && v.media) {
      const slide = root.querySelector(`[data-media-id="${v.media}"]`), track = slide && slide.parentElement;
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: REDUCE ? 'auto' : 'smooth' });
    }
    if (v && document.body.classList.contains('template-product') && history.replaceState) {
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
  }
  radios.forEach(r => r.addEventListener('change', () => paint(current())));
  paint(current() || variants.find(v => idInput && String(v.id) === idInput.value));
}

/* ---------- gallery ---------- */
function initGallery(g) {
  if (g.dataset.ready) return; g.dataset.ready = '1';
  const track = $('[data-gallery-track]', g), thumbs = $$('[data-thumb]', g); if (!track) return;
  thumbs.forEach(t => t.addEventListener('click', () => {
    const s = track.querySelector(`[data-media-id="${t.dataset.thumb}"]`);
    if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: REDUCE ? 'auto' : 'smooth' });
  }));
  let raf; track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
    });
  }, { passive: true });
}

/* ---------- sticky add-to-cart ---------- */
function initSticky() {
  const bar = $('[data-sticky-buy]'); if (!bar || bar.dataset.ready) return; bar.dataset.ready = '1';
  /* lift it out of the section's stacking context so later sections cannot paint over it */
  if (bar.parentElement !== document.body) document.body.appendChild(bar);
  const btn = bar.querySelector('[form]'), main = btn && document.getElementById(btn.getAttribute('form'));
  const target = main && (main.querySelector('[data-add]') || main); if (!target) return;
  const foot = $('.site-footer');
  let raf = 0;
  const check = () => {
    raf = 0;
    /* show once the main button has scrolled up out of view, hide again over the footer */
    const on = target.getBoundingClientRect().bottom < 0 && !(foot && foot.getBoundingClientRect().top < innerHeight * .6);
    if (on === bar.classList.contains('is-on')) return;
    bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); btn.tabIndex = on ? 0 : -1;
  };
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
  addEventListener('resize', check); check();
}

/* ---------- timers ---------- */
function parseEnd(s) {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(String(s || '').trim());
  return m ? new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), m[4] ? 0 : 59) : null;
}
function nextCutoff(el) {
  const now = new Date(), days = (el.dataset.days || '1,2,3,4,5').split(',').map(Number), h = +el.dataset.cutoff;
  const c = new Date(now); c.setHours(h, 0, 0, 0);
  return days.includes(now.getDay()) && now < c ? c : null;
}
function initTimer(el) {
  if (el.dataset.ready) return; el.dataset.ready = '1';
  const end = el.dataset.mode === 'cutoff' ? nextCutoff(el) : parseEnd(el.dataset.end);
  const host = el;
  if (!end || end <= new Date()) { host.hidden = true; return; }
  host.hidden = false;
  const d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el), pad = n => String(n).padStart(2, '0');
  if (el.dataset.mode === 'cutoff' && d) d.parentElement.hidden = true;
  const tick = () => {
    let t = Math.max(0, Math.floor((end - new Date()) / 1000));
    if (!t) { host.hidden = true; clearInterval(iv); return; }
    const dd = Math.floor(t / 86400); t %= 86400;
    d.textContent = pad(dd); h.textContent = pad(Math.floor(t / 3600)); m.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
  };
  const iv = setInterval(tick, 1000); tick();
}

/* ---------- delivery estimate ---------- */
function addBusinessDays(d, n) { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() % 6) n--; } return r; }
function initShipEst(el) {
  const now = new Date(), a = addBusinessDays(now, +el.dataset.min), b = addBusinessDays(now, +el.dataset.max);
  const f = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  el.textContent = el.dataset.text.replace('[dates]', f.format(a) + ' – ' + f.format(b));
}

/* ---------- announcement rotation ---------- */
function initAnnounce(el) {
  const msgs = $$('.announce__msg', el); if (msgs.length < 2 || REDUCE) return;
  let i = 0; setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, (+el.dataset.speed || 5) * 1000);
}

/* ---------- header: solid once scrolled, and its height for sticky offsets ---------- */
function initHeader() {
  const h = $('[data-header]'); if (!h) return;
  const set = () => document.documentElement.style.setProperty('--hdr', (h.closest('.header-section') || h).offsetHeight + 'px');
  set(); addEventListener('resize', set);
  const solid = () => h.classList.toggle('is-solid', scrollY > 40 || !document.body.classList.contains('template-index'));
  solid(); addEventListener('scroll', solid, { passive: true });
}

/* ---------- scroll reveal and counting numbers ---------- */
function initReveal() {
  const els = $$('[data-reveal]:not(.is-in)');
  if (!('IntersectionObserver' in window) || REDUCE) { els.forEach(e => e.classList.add('is-in')); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  els.forEach(e => io.observe(e));
  const nums = $$('[data-count-to]:not([data-counted])');
  const nio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; nio.unobserve(e.target); const el = e.target; el.dataset.counted = '1';
    const to = parseFloat(el.dataset.countTo), txt = el.textContent, pre = txt.slice(0, txt.indexOf(el.dataset.countTo)), post = txt.slice(txt.indexOf(el.dataset.countTo) + el.dataset.countTo.length);
    if (isNaN(to) || to < 2) return;
    const t0 = performance.now(), dur = 1600;
    const step = now => { const k = Math.min(1, (now - t0) / dur), v = Math.round(to * (1 - Math.pow(1 - k, 3))); el.textContent = pre + v + post; if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }), { threshold: .6 });
  nums.forEach(n => nio.observe(n));
}

/* ---------- links that should land on the buy box ---------- */
document.addEventListener('click', e => {
  const a = e.target.closest('a[data-scroll-buy]'); if (!a) return;
  const href = a.getAttribute('href') || ''; if (!href.startsWith('#')) return;
  const t = document.getElementById(href.slice(1));
  e.preventDefault();
  $$('.drawer.is-open').forEach(closeLayer);
  if (t) t.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
  else location.href = (T.routes.root || '/') + href;
});

/* ---------- popup ---------- */
function initPopup() {
  const p = $('#Popup'); if (!p) return;
  /* a signup anywhere on the page counts: never ask again */
  if (/customer_posted=true/.test(location.search)) { store.set('pod-popup', '1'); return; }
  if (p.hasAttribute('data-off') || store.get('pod-popup') || (window.Shopify && Shopify.designMode)) return;
  let shown = false;
  const show = () => { if (shown || $('.drawer.is-open') || document.documentElement.classList.contains('intro')) return; shown = true; store.set('pod-popup', '1'); openLayer(p); };
  setTimeout(show, (+p.dataset.delay || 15) * 1000);
  if (p.dataset.exit === 'true' && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 10) show(); });
}

/* ---------- misc ---------- */
function initSelects() { $$('select[data-default]').forEach(s => { if (s.dataset.default) s.value = s.dataset.default; }); }

/* ---------- add-ons + offer box ---------- */
function paintAddons(ao) {
  const checked = $$('[data-addon]:checked', ao), out = $('[data-addon-total]', ao);
  const buy = ao.closest('[data-buy]'), btn = buy && $('[data-add]', buy);
  const base = +ao.dataset.base || 0, extra = checked.reduce((n, c) => n + (+c.dataset.price || 0), 0);
  if (out) { out.hidden = !checked.length; out.innerHTML = checked.length ? `${checked.length + 1} items together: <b>${esc(formatMoney(base + extra))}</b>` : ''; }
  if (btn && !btn.disabled) { btn.dataset.baseLabel = btn.dataset.baseLabel || btn.textContent.trim(); btn.textContent = checked.length ? `Add ${checked.length + 1} items to cart` : btn.dataset.baseLabel; }
}
document.addEventListener('change', e => {
  const sel = e.target.closest('[data-addon-variant]');
  if (sel) {
    const item = sel.closest('.ao__item'), cb = $('[data-addon]', item), o = sel.selectedOptions[0];
    cb.value = sel.value; cb.dataset.price = o.dataset.price; const pr = $('[data-addon-price]', item); if (pr) pr.textContent = o.dataset.money;
  }
  const ao = e.target.closest('[data-addons]'); if (ao) paintAddons(ao);
  const gs = e.target.closest('[data-gift-size]'); if (gs) store.set('podGift' + gs.dataset.product, gs.value);
});
function initOffer(box) {
  if (offerOver()) { box.hidden = true; return; }
  $$('[data-gift-size]', box).forEach(s => { const v = store.get('podGift' + s.dataset.product); if (v && $(`option[value="${v}"]:not([disabled])`, s)) s.value = v; });
  const li = $('[data-eo-ship]', box); if (!li || !T.freeShip) { if (li) li.hidden = true; return; }
  const goal = Math.round(T.freeShip * rate());
  if (+li.dataset.price < goal) {
    $('[data-eo-ship-title]', li).textContent = 'Free shipping over ' + formatMoney(goal);
    $('[data-eo-ship-sub]', li).textContent = 'Add an item below to unlock it';
    $('[data-eo-ship-val]', li).textContent = '';
  }
}

function init(scope = document) {
  $$('[data-elite-offer]', scope).forEach(initOffer);
  $$('[data-buy]', scope).forEach(initBuy);
  $$('[data-gallery]', scope).forEach(initGallery);
  $$('[data-countdown]', scope).forEach(initTimer);
  $$('[data-ship-est]', scope).forEach(initShipEst);
  $$('[data-announce]', scope).forEach(initAnnounce);
  initReveal();
}
init(); initHeader(); initSticky(); initPopup(); initSelects();
if (T.freeShip && ($('[data-ship-bar]'))) getCart().then(paintShipBars).catch(() => {});
if (document.body.classList.contains('template-cart') && OD.gifts && OD.gifts.length) getCart().then(async c => { const n = await syncGifts(c); if (n !== c) location.reload(); }).catch(() => {});
document.addEventListener('shopify:section:load', e => { init(e.target); initSticky(); });
window.PODTheme = { toast, refreshCart, formatMoney };
})();
